import { defineStore } from 'pinia'
import TokeService from '@/api/TokenService.js'

export const useTokenStore = defineStore('token', {
    state: () => ({
        saving: false,
        revoking: false,
        tableRefreshKey: 0,
    }),

    getters: {},

    actions: {
        notification(severity, detail) {
            const summary = severity === 'error' ? 'Error' : 'Success'
            this.toast.add({
                severity,
                summary,
                detail,
                life: this.getToastDuration(detail, severity),
            })
        },

        async create(user, name) {
            this.saving = true
            try {
                const { data } = await TokeService.create(user, name)
                this.notification('success', '§ui_message.create_successful')
                this.tableRefreshKey += 1
                return data.accessToken
            } catch (error) {
                this.notification('error', '§ui_message.save_failed')
                console.error('Error saving token (stores/token/create):', error)
            } finally {
                this.saving = false
            }
        },

        async revoke({ token, for_user }) {
            this.revoking = true
            try {
                await TokeService.revoke(token, for_user)
                this.notification('success', '§ui_message.save_successful')
                this.tableRefreshKey += 1
            } catch (error) {
                this.notification('error', '§ui_message.revoke_failed')
                console.error('Error revoking token (stores/token/revoke):', error)
            } finally {
                this.revoking = false
            }
        },
    },
})
